import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import {RESOURCES as locationsResources} from '../fuseLocationsResourceMap';
import {checkTokenStatus} from '../shared/tokenFunctions';
import axios from 'axios';
import {getGetHeaders} from '../shared/functions';

const styles = {
    buttonContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        marginTop: 4,
    }
};

class SendEmailButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: (props.record && props.record.email) ? props.record.email : null,
            isDistrictManager: (props.record && props.record.district_id) ? props.record.district_id : null,
            isLoading: false,
            message: ''
        };

        this.fetchData = this.fetchData.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.record.email !== this.props.record.email) {
            this.setState({
                email: nextProps.record.email,
            });
        }
    }

    fetchData() {
        this.setState({
            isLoading: true
        });
        let params = {
            email: this.state.email,
        };
        let resource = locationsResources.DistrictEmail.GET_ONE(params);

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.error) {
                console.error(result.error);
            }
            this.setState({
                message: "Email sent.",
                isLoading: false
            });
        }).catch((error) => {
            if (error.response) {
                // Server response outside 2xx
            } else if (error.request) {
                // No response
            } else {
            }
            this.setState({
                message: "There was an error sending the email.",
                isLoading: false
            });
        });
    }

    render() {
        const {
            message, isLoading, isDistrictManager, email
        } = this.state;

        const {label} = this.props;
        console.log(isDistrictManager, email)

        return (
            <Fragment>
                {isDistrictManager && email &&
                    <div style={styles.buttonContainer}>
                        <RaisedButton primary label={label} disabled={isLoading} onClick={this.fetchData}/>
                        {message && <span>{message}</span>}
                    </div>
                }
            </Fragment>
        );
    }
}

SendEmailButton.propTypes = {
    label: PropTypes.string,
};

export default SendEmailButton;



// WEBPACK FOOTER //
// ./src/Fuse/buttons/SendEmailButton.js